import AuthStateService from './AuthStateService.js';
import AuthDataService from './AuthDataService.js';
import fdxUtils from './fdxUtils';

angular.module('feedAuthApp')
  .service('AuthStateService', AuthStateService)
  .service('AuthDataService', AuthDataService)
  .service('fdxUtils', fdxUtils);
